import { render, staticRenderFns } from "./CombinationsProductDropdowns.vue?vue&type=template&id=3dbd05c6&scoped=true"
import script from "./CombinationsProductDropdowns.vue?vue&type=script&setup=true&lang=ts"
export * from "./CombinationsProductDropdowns.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CombinationsProductDropdowns.vue?vue&type=style&index=0&id=3dbd05c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbd05c6",
  null
  
)

export default component.exports